const indicar_ensino_fase_concluida = [
  {
    path: "/indicar-ensino-fase-concluida",
    name: "indicar_ensino_fase_concluida",
    meta: {
      requireAuth: false,
      breadCrumb: "Processo de Resultado Final - Correção de Fluxo",
    },
    component: () =>
      import("@/views/IndicarEnsinoFaseConluida/IndicarEnsinoFaseConluida.vue"),
  },
];

export { indicar_ensino_fase_concluida };
